<template>
  <div class="div-block-43 _0">
    <div class="text-block-11">
      <strong>Persoonsgegevens</strong>
    </div>
    <div class="div-block-44">
      <InputField
        :placeholder="'voornaam'"
        :initial_value="this.$store.state.user_info.firstname"
        @return="setStore('firstname', $event)"
      />
      <InputField
        :placeholder="'achternaam'"
        :initial_value="this.$store.state.user_info.lastname"
        @return="setStore('lastname', $event)"
      />
    </div>
    <div class="div-block-44 _1">
      <InputField
        :placeholder="'email'"
        :initial_value="this.$store.state.user_info.email"
        @return="setStore('email', $event)"
      />
    </div>
  </div>
</template>

<script>
import InputField from "@/elements/InputField.vue"
export default {
  components: {
    InputField,
  },
  methods: {
    setStore(key, value) {
      this.$store.state.user_info[key] = value
    },
  },
}
</script>

<style scoped>
.div-block-44 {
  grid-template-columns: 1fr 1fr;
}
.div-block-44._1 {
  grid-template-columns: 1fr;
}

.div-block-43._0 {
  margin-top: 5%;
}
</style>
